var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{on:{"mousewheel":_vm.mousewheelHandle}},[_c('header-top'),_c('first-screen'),_c('page2'),_c('page3'),_c('home-projects'),_c('team-introduction'),_c('page5'),_c('page6'),_c('contact-us'),_c('foot-bottom')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }